import { Skeleton } from '@components'

const BannerLoader = () => {
  return (
    <>
      <Skeleton width="100%" height={'100%'} radius={12} />
    </>
  )
}

export default BannerLoader
